import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { forwardRef, type MouseEventHandler, type SVGAttributes } from "react"

import styles from "./Checkbox.module.css"

export interface CheckboxProps {
  checked?: boolean
  disabled?: boolean
  onCheckedChange?: (checked: boolean) => void
  onClick?: MouseEventHandler<HTMLButtonElement>
  tabIndex?: number
}

export function Checkbox(props: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root {...props} className={styles.root}>
      <CheckboxPrimitive.Indicator asChild>
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

const CheckIcon = forwardRef<SVGSVGElement, SVGAttributes<SVGSVGElement>>(
  function CheckIcon(props, ref) {
    return (
      <svg
        {...props}
        fill="none"
        height="18"
        ref={ref}
        viewBox="0 0 18 18"
        width="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 9L8 12L13 6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    )
  }
)
